import { render, staticRenderFns } from "./escalationrules.vue?vue&type=template&id=37313d50&scoped=true&lang=pug"
import script from "./escalationrules.vue?vue&type=script&lang=js"
export * from "./escalationrules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37313d50",
  null
  
)

/* custom blocks */
import block0 from "./escalationrules.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports